import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { CustomResourceRouteParams } from "../../../../common/types";
import { ResourceContextProvider, Create } from "react-admin";
import { EditActions } from "../../../common/form/FormActions";
import resourceNames from "../../../../common/data/resourceNames";
import { DriverLogStatusForm } from "./DriverLogStatusForm";
import "./DriverLogAddStatus.css";

interface Props extends RouteComponentProps<CustomResourceRouteParams> {
  onClose: () => void;
  onSuccess: () => void;
  timeZone?: string | null;
}

export const DriverLogAddStatus = ({ timeZone, ...props }: Props) => {
  return (
    <ResourceContextProvider value={`${resourceNames.HOS_EVENTS}`}>
      <div id="driver-log-add-status-container">
        <Create
          title=" "
          basePath={`/${resourceNames.HOS_DRIVER_LOG_VIEW}/${props.match.params.driverId}/${props.match.params.date}`}
          resource={`${resourceNames.HOS_EVENTS}`}
          onSuccess={() => {
            props.onSuccess();
          }}
          actions={<EditActions onClose={props.onClose} />}>
          <DriverLogStatusForm timeZone={timeZone} />
        </Create>
      </div>
    </ResourceContextProvider>
  );
};
